import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { usePaginasWebContext } from "../paginas-web-context";
import { PaginaWebProvider, usePaginaWebContext } from "./pagina-web-context";
import { direccionWebRegex } from "app/utils/regexps";
import { MdArrowBack } from "react-icons/md";

export function PaginaWebForm() {
  return (
    <PaginaWebProvider>
      <Form />
    </PaginaWebProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const { addPaginaWeb, isAdding, updatePaginaWeb, isUpdating, cancel } =
    usePaginasWebContext();

  const { paginaWeb, setPaginaWeb, isEditing } = usePaginaWebContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updatePaginaWeb({
          paginaWebId: params.pagina_web_id,
          paginaWeb,
        });
      } else {
        return await addPaginaWeb({ paginaWeb });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../..", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${
                    !!isEditing ? "Editar" : "Agregar"
                  } dirección de página web`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!paginaWeb.pagina_web_verificada
                      ? "Verificado"
                      : "Pendiente"
                  }
                  color={
                    !!paginaWeb.pagina_web_verificada ? "success" : "warning"
                  }
                  size="small"
                  variant="outlined"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Dirección de página web"
              value={paginaWeb.pagina_web_url}
              onChange={(e) =>
                setPaginaWeb((pagina) => ({
                  ...pagina,
                  pagina_web_url: e.target.value,
                }))
              }
              inputProps={{
                pattern: direccionWebRegex.pattern,
                title: direccionWebRegex.title,
              }}
              size="small"
              fullWidth
              required
              disabled={!!paginaWeb.pagina_web_verificada}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={paginaWeb.pagina_web_principal}
                    onChange={(e) =>
                      setPaginaWeb((pagina) => ({
                        ...pagina,
                        pagina_web_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es una dirección de página web principal?"
                disabled={!!paginaWeb.pagina_web_verificada}
              />
            </FormGroup>
          </Grid>

          {!paginaWeb.pagina_web_verificada && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  variant="outlined"
                  size="small"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
}
